var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HotelDatePicker',{attrs:{"format":"DD/MM/YYYY","startDate":null,"startingDateValue":_vm.privateStartDate,"endingDateValue":_vm.privateEndDate,"i18n":_vm.dateRangeI18n},on:{"check-in-changed":_vm.changeDateFrom,"check-out-changed":_vm.changeDateTo}})
}
var staticRenderFns = []

export { render, staticRenderFns }